class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.id = this.details.id
    this.open = this.id ? document.querySelectorAll(`[data-details-open=${this.id}]`) : null
    this.button = this.querySelector('summary')
    this.content = this.details.querySelector('summary').nextElementSibling;
    this.overlay = this.content.querySelector('.popup__overlay')

    this.onKeyup()
    if(this.open !== null) { 
      this.open.forEach(btn => btn.addEventListener('click', this.onExternalClick.bind(this)));
    }
    this.addEventListener('click', this.onClick.bind(this))
  }
  onKeyup() { 
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('keyup', (evt) => { 
      if(evt.target.classList.contains('menu-drawer__btn') && evt.code === 'Enter') { 
        this.close()
      }
    })
  }
  updateStyles() { 
    const membership = this.querySelector('.popup__inner.membership__inner')
    const filter = document.querySelector('filter-new')
    if(filter) { 
      const activeFilters = filter.querySelector('.active-filters') || filter.querySelector('.blog-filter__active-tags')
      document.documentElement.style.setProperty('--scrollbar-padding', `${activeFilters.getBoundingClientRect().height + 50}px`);
    }
    if(membership) { 
      let totalHeight = 0
      const header = membership.querySelector('header')
      header ? totalHeight += header.getBoundingClientRect().height : ''
      document.documentElement.style.setProperty('--scrollbar-padding', `${totalHeight}px`);
    }
  }
  onExternalClick() { 
    this.details.querySelector('summary').click();
  }
  onClick(event) {
    const target = event.target
    if(target === this.button || target.hasAttribute('data-details-open')) { 
      event.preventDefault()
      this.onToggle()
    }
    if(target.classList.contains('popup__overlay') || target.classList.contains('btn--cancel')) { 
      event.stopPropagation();
      this.close()
      this.clearSearchForm()
    }
  }
  clearSearchForm() { 
    if(this.querySelector('.predictive-search-results')) { 
      const predictiveSearch = this.querySelector('predictive-search')
      const searchForm = predictiveSearch.querySelector('#predictive-search')
      const searchInput = predictiveSearch.querySelector('.predictive-search input[type="search"]')
      searchInput.value = ''
      searchForm.classList.remove('open')
      searchForm.innerHTML = ''
    }
  }
  onToggle() {
    if (this.details.hasAttribute('open')) {
    	this.close()
    } else {
      this.details.open = true
      this.updateStyles()
      this.querySelector('summary').setAttribute('aria-expanded', true)
      this.closeModals()
  	}
  }
  closeModals() { 
    const modals = document.querySelectorAll('details')
    modals.forEach(modal => {
      if(!modal.classList.contains('main-nav__menu') && modal !== this.details) { 
        this.close(modal)
      }
    })
  }
  close(target) {
    const modal = target ? target : this.details
    modal.classList.add('is-closing')
    setTimeout(() => {
      modal.open = false
      modal.classList.remove('is-closing')
    }, 200)
    modal.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);